import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const ProfileRFVForm = ({
  visible,
  onClose,
  node,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Campeões", value: "CAMPEOES" },
    { label: "Hibernando", value: "HIBERNANDO" },
    { label: "Em risco", value: "EM_RISCO" },
    { label: "Requer atenção", value: "REQUER_ATENCAO" },
    { label: "Desligando", value: "DESLIGANDO" },
    { label: "Abandonados", value: "ABANDONADOS" },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.ProfileRFV}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        timerange={false}
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
